module.exports = __webpack_public_path__ + "static/media/beretta.10a41f39.png";